/* theme/assets/fm-dates.js — Formula date helpers (spec 2026-10-02 §5.2, §6.2). Pure — no DOM.
   Browser: window.FmDates; tests: globalThis.FmDates. */
(function (root) {
  const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
  /** The day an order placed at `now` ships: `days` business days on (weekends skipped unless skipWeekends is false); at or after `cutoffHour` the order counts from tomorrow. */
  function shipsBy(now, o = {}) {
    const days = Math.max(0, Number(o.days ?? 1) || 0);
    const cutoff = Number(o.cutoffHour ?? 24);
    const skip = o.skipWeekends !== false;
    const d = new Date(now.getTime());
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    while (skip && isWeekend(d)) d.setDate(d.getDate() + 1);
    let added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (!skip || !isWeekend(d)) added += 1; }
    return d;
  }
  function formatShipDate(d, locale) {
    try { return new Intl.DateTimeFormat(locale || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' }).format(d); }
    catch (e) { return d.toDateString().slice(0, 10); }
  }
  /** Seconds left until `end` (unix seconds), or null when there is no end or it has passed. */
  function remaining(end, nowMs) {
    const e = Number(end);
    if (!e) return null;
    const left = Math.floor(e - nowMs / 1000);
    return left > 0 ? left : null;
  }
  /** The visitor's coming local midnight (unix seconds): the end of a countdown that restarts every day. */
  function nextMidnight(nowMs) {
    const d = new Date(nowMs);
    d.setHours(24, 0, 0, 0);
    return d.getTime() / 1000;
  }
  function parts(seconds) {
    const p = (n) => String(n).padStart(2, '0');
    return { h: p(Math.floor(seconds / 3600)), m: p(Math.floor((seconds % 3600) / 60)), s: p(seconds % 60) };
  }
  root.FmDates = { shipsBy, formatShipDate, remaining, nextMidnight, parts };
})(typeof window !== 'undefined' ? window : globalThis);
